import {router} from '@/router/router';

const toPage = (path: string, query?: any) => {
  router.push({
    path: path,
    query: query
  });
};
const openInNewWindow = (routePath: string, query?: any) => {
  const routeData = router.resolve({ path: routePath, query });
  window.open(routeData.href, '_blank');
}

export {
  toPage,
  openInNewWindow
};
